import { PieChart } from 'react-minimal-pie-chart'

import SVGImage from '~/components/Image/SVGImage'
import { Size } from '~/statistics/types/profile-card.types'

interface Props {
  percentage: number
  size?: Size
  hideCheckmark?: boolean
}

const getHeightClass = (size: Size): string => {
  if (size === Size.LARGE) {
    return 'h-24'
  } else {
    return 'h-6 w-6'
  }
}

export default function CircularProgress({
  hideCheckmark = false,
  size = Size.SMALL,
  percentage = 0,
}: Props): React.ReactElement {
  return (
    <div className="relative">
      <PieChart
        className={getHeightClass(size)}
        data={[
          { value: percentage, color: '#7D38D6' },
          { value: 100 - percentage, color: '#AFAFAF' },
        ]}
        lineWidth={28}
        startAngle={270}
      />
      {!hideCheckmark && percentage === 100 && (
        <SVGImage height={20} imageClassName="absolute left-1 -top-0.5" srcKey="scoreboard/tick.svg" width={26} />
      )}
    </div>
  )
}
